// Small, dependency-free text helpers shared by the portal renderer and the
// historical importer. These exist to guarantee that NO raw internal token
// (an option value like `50_offset`, a product key like `media_replication`)
// and NO garbled legacy title ever reaches a partner un-tidied.
//
// These are last-resort / import-seam helpers, NOT a replacement for the
// authored labels. The portal's first choice is always the schema's own
// `enum_options[].label`; humanizeToken only runs when a stored value has no
// matching option in the active served schema (e.g. a legacy historical value
// whose option was retired). See v2_FORM_SCHEMA_FORMAT.md.
// Turn a raw token into a readable, title-cased label:
//   `50_offset`         → `50 Offset`
//   `media_replication` → `Media Replication`
// Underscores become spaces, runs of whitespace collapse, and each word is
// capitalized. Returns the input unchanged if it's blank after trimming.
export function humanizeToken(token) {
    const spaced = token.replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
    if (!spaced)
        return token;
    return spaced
        .split(' ')
        .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
        .join(' ');
}
// Tidy a legacy quote/opportunity title copied verbatim from the source
// system, which sometimes runs a word into a trailing count (the observed
// "Business cards7 titles" shape, where "Business cards" and "7 titles" were
// concatenated during a legacy extraction).
//
// The only transform is inserting a space between a word and a count that ran
// into it — and it is deliberately conservative so it never mangles a
// legitimate title: it fires ONLY when at least two lowercase letters are
// immediately followed by digits that are themselves followed by another word.
// That guard leaves dimensions and unit/model tokens intact:
//   "Business cards7 titles" → "Business cards 7 titles"   (fixed)
//   "8.5x11 poster"          → "8.5x11 poster"             (untouched — no 2-letter run)
//   "A4 flyer" / "10pt cover" / "5x7 cards" / "Q3 deck"    (untouched)
// Idempotent: running it on already-tidied text is a no-op.
export function normalizeLegacyTitle(title) {
    return title
        .replace(/([a-z]{2})(\d+)(?=\s+[A-Za-z])/g, '$1 $2')
        .replace(/\s{2,}/g, ' ')
        .trim();
}
//# sourceMappingURL=humanize.js.map